/* @flow */

import React from 'react';

import InformationPage from './InformationPage';

const ZkaiTerm = () => (
  <InformationPage
    subtitle={
      <React.Fragment>
        ※13さいになっていない
        <ruby>
          場<rt>ば</rt>合<rt>あい</rt>
        </ruby>
        は、おうちの
        <ruby>
          人<rt>ひと</rt>
        </ruby>
        に
        <ruby>
          読<rt>よ</rt>
        </ruby>
        んでもらってください。
      </React.Fragment>
    }
    hasCloseButton={true}
    title="利用規約"
  >
    <p>
      この利用規約（以下、「本規約」といいます）は、株式会社Z会のプログラミング学習「Z-pro」をとおして、株式会社ソニー・グローバルエデュケーション（以下「SGED」といいます）が提供する、体験型プログラミング教育サービス（以下、「本サービス」といいます）の利用条件を定めるものであり、本サービスを利用されるお客様（以下「お客様」または「ユーザー」といいます）に適用されます。
    </p>
    <p>
      本サービスは、欧州地域に居住または滞在されていらっしゃるお客様を対象としていません。欧州地域に居住または滞在されていらっしゃるお客様は、本サービスのご利用をお控えくださいますようお願いいたします。本サービスをご利用いただくには、本規約において定める諸条件にご同意いただく必要があります。本規約をよくお読みになり、ご同意の上、本サービスをご利用くださいますようお願い申し上げます。
    </p>
    <h3>ご注意</h3>
    <p>
      お子様が本サービスをご利用になる際は、一定の制限および追加要件が課されます。お客様が13歳以上かつ18
      歳未満の場合、本サービスをご利用されるには保護者の方の同意を得ていただくようお願いいたします。お客様が13
      歳未満の場合、保護者の方に本規約に同意いただく必要があります。保護者の方は、ご利用をされるお子様にも、本規約の内容をご説明のうえ、ご同意を得ていただくようお願いいたします。
    </p>
    <h3>1. 本サービスについて</h3>
    <p>
      本サービスには、本サービスにおいて提供されるコンテンツのほか、本サービスを利用するために必要となるSGED またはSGED
      に使用を許諾した第三者のソフトウェア並びにそれらのアップデート・アップグレード版（以下、総称して「関連ソフトウェア等」といいます）も含まれ、ユーザーの関連ソフトウェア等の使用にも本規約が適用されます。SGED
      は、自らの裁量で、関連ソフトウェア等を含む本サービスの全部または一部を変更することができます。当該変更に伴い、本サービスの機能が追加、変更又は削除されることがあります。本サービスのご利用を継続いただくには、関連ソフトウェア等のアップデートなど、当該変更を行っていただくことが条件となる場合があります。
    </p>
    <h3>2. 禁止事項</h3>
    <h4>
      (1)
      ユーザーは本サービスのご利用にあたり、本規約を遵守するとともに、以下のような行為を行ってはならないものとします。
    </h4>
    <br />
    <ol>
      <li>
        ① SGED
        の事前の書面による承諾なく、本サービスを複製、修正、頒布、改変、改ざん、リバースエンジニアリング、逆コンパイル、逆アセンブル、消去等すること。
      </li>
      <li>② SGED の事前の書面による承諾なく、本サービスを使用して営利を目的とした活動をすること。</li>
      <li>
        ③ 本サービスにアクセスし、インデックス若しくはフレームを作成し、又はリンクするためにSGED
        によって許可されていない技術又はその他の手段を利用すること（本サービスの不正なダウンロード、キャプチャ、リンク設定、フレーム作成、複製、アクセス又は配信の防止を目的とするコンテンツ保護又はアクセスコントロール機能を削除、無効化、迂回又は回避することを含みます）。
      </li>
      <li>④ 本サービスを毀損し、無効化し、過度の負担を課し、損ない、又は不正にアクセスすること。</li>
      <li>⑤ 刑事犯罪を構成し又は民事責任の生じるような行為を助長すること。</li>
      <li>⑥ 本規約又はSGED によって掲載される指針若しくは方針に違反すること。</li>
      <li>⑦ 上記のいずれかを企てること。</li>
    </ol>
    <br />
    <h4>
      (2) SGED
      が自らの裁量においてユーザーが本規約に違反していると判断した場合、SGEDは、ユーザーに通知を行い、また、ユーザーの本サービスへのアクセス又はご利用を阻止又は制限するための技術的手段を用いることができるものとします。その場合、ユーザーは、いかなる方法による本サービスへのアクセス又はご利用（あるいはそれらを試みること）も直ちに中止し、また、ユーザーは、かかる制限を避けたり、回避したり、又は迂回したり、あるいはかかるアクセス又は利用をその他の方法で回復したり、又は回復しようと試みたりしないものとします。
    </h4>
    <br />
    <h4>
      (3) 法令等によって要請されない限り、本サービス上のコミュニケーションを含むユーザーのオンライン活動に関して、SGED
      は監視する義務を負いません。ただし、SGED
      は、法令や本規約の遵守の確保等の正当な目的のため、法令により認められた範囲内で、本サービス上のオンライン活動を記録し、また、これを閲覧、開示等することができるものとします。SGED
      は独自の判断で、どのようなコンテンツでも本サービス上から削除する権利を保有しています。
    </h4>
    <h3>3. リンクサイト</h3>
    <p>
      本サービスから、もしくは本サービスへリンクを張っているSGED
      以外の第三者のウェブサイト（以下「リンクサイト」といいます）の内容は、それぞれ各社の責任で管理されるものであり、SGED
      の管理下にあるものではありません。リンクサイトは、それぞれのリンクサイトの掲げる使用条件に従ってご利用下さい。SGED
      はリンクサイトの内容について、また、それらをご利用になったことにより生じたいかなる損害についても責任を負いません。尚、本サービスへのリンクという事実は、SGED
      が同リンクサイトの利用や、リンクサイトに掲載されている商品、サービス、会社等を推奨することを意味するものではなく、また、SGED
      とリンクサイトとの間に必ずしも提携などの特別な関係があるということを意味するものではありません。
    </p>
    <h3>4. 知的財産権</h3>
    <ol>
      <li>
        (1) 本サービスおよび関連ソフトウェア等の知的財産権その他の権利は、SGED またはSGED
        に使用を許諾した原権利者（以下「原権利者」とします）に帰属します。
      </li>
      <li>
        (2) SGED
        は、関連ソフトウェア等を、本規約に従って本サービスを利用する目的で使用する、非独占的な権利をユーザーに許諾するものとし、ユーザーは、それ以外の目的では関連ソフトウェア等を一切使用してはならないものとします。
      </li>
      <li>
        (3)
        関連ソフトウェア等には、本規約とは異なる使用許諾条件を原権利者が定めたソフトウェア（以下「対象外ソフトウェア」とします）が含まれている場合があります。対象外ソフトウェアのご使用は、各権利者の定める使用許諾条件に従っていただくものとします。
      </li>
    </ol>
    <h3>5. プライバシー</h3>
    <p>
      本サービスの運営および提供のため、SGED は、
      <a className="proc-link" target="_blank" rel="noopener noreferrer" href="/z-pro-privacy">
        本サービスのプライバシーポリシー
      </a>
      に従い、一定の情報を収集し、使用いたします。ユーザーは、本サービスをご利用される場合、SGED
      が上記のプライバシーポリシーに従ってユーザーの個人情報を収集および使用することについて同意したものとします。当該収集および使用について同意いただけない場合、本サービスをご利用することはできません。
    </p>
    <h3>6. 安全管理</h3>
    <p>
      SGED は情報の逸失、不適切な利用、改変に対して、SGED
      が必要かつ適切と考える安全管理措置を講じ、ユーザーの情報を保護するための努力を払ってまいります。しかしながら、SGED
      は、本サービスを通じ収集する情報、SGED
      が自らのシステムに保存する情報、または業務委託先のシステムに保存する情報について完全なセキュリティを保証するものではありません。
    </p>
    <h3>7. 本サービスの終了、中断</h3>
    <ol>
      <li>
        (1) SGED
        は、ユーザーが本規約に違反していると判断した場合、自己および第三者の利益を守るために、本サービスへのアクセスの禁止、その他救済のために必要とSGED
        が判断するあらゆる手段をとることができるものとします。
      </li>
      <li>
        (2) SGED
        は、自己の裁量により、ユーザーに事前に通知することなく、本サービスの一部または全部の提供を終了または中断させていただくことがあります。但し、SGED
        は、本サービスの全部または一部の終了・中断に際し、それによりユーザーに大きな影響を与える場合には、緊急やむを得ない場合を除きあらかじめユーザーに通知をしたうえでこれを行うものとします。
      </li>
    </ol>
    <h3>8. 免責事項および責任の制限</h3>
    <ol>
      <li>
        (1) SGED
        は、本サービスの品質、機能、利用可能性、商品性、特定の目的への適合性または動作について、明示的であるか黙示的であるか法令上のものであるか否かにかかわらず、いかなる保証もいたしません。
      </li>
      <li>
        (2) 本規約の他の規定にかかわらず、SGED
        は、その債務不履行または不法行為によりユーザーに損害が生じた場合、ユーザーに通常生じうる損害の範囲に限りこれを賠償する責任を負うものとし、特別な事情から生じた損害等(損害発生を予見しまたは予見し得た場合を含みます)については一切責任を負わないものとします。但し、SGED
        は、その故意または重大な過失による債務不履行または不法行為に起因してユーザーに生じた損害に対する賠償責任については、免責されないものとします。
      </li>
      <li>
        (3)
        本サービスのご利用にあたっては、インターネット環境が必要となります。インターネット環境の整備、セキュリティおよびその費用についての責任はユーザーにあるものとします。
      </li>
    </ol>
    <h3>9. SGED または第三者に対する責任</h3>
    <p>
      ユーザーは、本サービスの利用によりSGED
      または第三者に対して損害を与えた場合（ユーザーが本規約上の義務を履行しないことにより、SGED
      または第三者が損害を被った場合を含みます。）、ユーザー自身が自らの費用で解決するものとし、SGED
      または第三者に一切の迷惑をかけないものとします。
    </p>
    <h3>10. 本規約の変更</h3>
    <p>
      SGED は、法令で認められた範囲において、本規約を随時変更することができるものとします。SGED
      は、変更後の本規約の適用開始に先立ち、変更内容等に照らしてSGED
      が合理的と判断する事前告知期間を設定したうえで(ただし、本規約の変更内容がユーザーの一般の利益に適合するものである場合は事前告知期間を定めないことができるものとします)、変更後の本規約を本サービスのウェブサイト等を通じてユーザーに周知いたします。
    </p>
    <h3>11. 準拠法および裁判管轄</h3>
    <p>
      本規約に関する準拠法は、日本法とします。SGED
      とユーザーとの間に紛争が生じた場合には、東京地方裁判所を第一審の専属合意管轄裁判所とします。
    </p>
    <h3>12. その他</h3>
    <ol>
      <li>
        (1) 本規約は、ユーザーとSGED
        との間の完全なる法的合意を構成するものであり、ユーザーによる本サービスの利用に適用されるものであって、本サービスに関するユーザーとSGED
        との間の一切の従前の合意に完全に取って代わるものです。
      </li>
      <li>
        (2)
        本規約の一部条項が法令によって無効となった場合でも、当該条項は法令で有効と認められる範囲で依然として有効に存続するものとします。
      </li>
      <li>
        (3) SGED
        が本規約に基づく権利又は救済の行使又は執行を直ちに行わないと判断した場合であっても、かかる権利又は救済に関して権利放棄したことにはなりません。ユーザーから見て本規約と相容れない行為をSGED
        が行った場合であっても、SGED の行為を本規約に係る権利放棄又は解釈上の変更とみなすことはできません。
      </li>
      <li>
        (4) SGED
        は、自己の裁量で本サービスおよび本規約を第三者に譲渡することができます。ユーザーは、ユーザーとして有する権利を、第三者に譲渡することはできないものとします。
      </li>
    </ol>
    <div className="notice">Last Updated: 2022/06/06</div>
    <p>
      旧版は
      <a target="_blank" href="/z-pro-term-old">
        こちら
      </a>
    </p>
  </InformationPage>
);

export default ZkaiTerm;
